import type { CollectableItem } from "../collectableItem";
import { type TintConfig, type Tintable } from "../interfaces";
import { deserializeItem, deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { LootBox } from "./lootBox";
import { NightVisionEquipment } from "../items/nightVisionEquipment";

export class NightVisionLootBox extends LootBox implements Tintable {
	static key = "NightVisionLootBox";

	constructor(xy: XY, loot: CollectableItem[] = [new NightVisionEquipment(1)]) {
		super(xy, loot);
	}

	getTint(): TintConfig | null {
		return { r: 255, g: 255, b: 255, minAlpha: 0.0, maxAlpha: 0.3 };
	}

	getAnimationSpeedMultiplier(): number {
		return 1.0;
	}

	static deserialize(data: any): NightVisionLootBox {
		const box = new NightVisionLootBox(deserializeXY(data.xy));
		box.visualId = data.visualId;
		if (data.loot) {
			box.loot = data.loot.map((d: any) => deserializeItem(d));
		}
		return box;
	}
}
